var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { PeriodSearchResult } from "./PeriodSearchResult";
export class PeriodSearchResponse {
  constructor(_data) {
    /**
     */
    __publicField(this, "Count");
    /**
     */
    __publicField(this, "Hits");
    /**
     * Adds support for polymorphism. The discriminator is the schema property
     * name that is used to differentiate between other schema that inherit this
     * schema.
     *
     * @protected
     * @type {string}
     * @memberof PeriodSearchResponse
     */
    __publicField(this, "$type", "V1.Cesop.Periods.Search.PeriodSearchResponse");
    if (_data) {
      for (const property in _data) {
        if (_data.hasOwnProperty(property)) {
          this[property] = _data[property];
        }
      }
    }
  }
  /**
   * Initializes a new model instance.
   */
  init(_data) {
    if (_data) {
      this.Count = _data["Count"];
      if (_data["Hits"] && _data["Hits"].constructor === Array) {
        this.Hits = [];
        for (let item of _data["Hits"]) {
          const hits_ = new PeriodSearchResult();
          this.Hits.push(hits_.init(item));
        }
      }
    }
    return this;
  }
  toJSON(_data) {
    _data = typeof _data === "object" ? _data : {};
    _data["Count"] = this.Count;
    if (this.Hits && this.Hits.constructor === Array) {
      _data["Hits"] = [];
      for (let item of this.Hits) {
        _data["Hits"].push(item.toJSON());
      }
    }
    return _data;
  }
}
